export default __webpack_public_path__ + "static/media/logo.7ed0c9f2.png";